/**
 * UserStatus DB operations.
 */

import { getDb, getNow } from "./runtime.js"
import { ok, fail } from "./op-types.js"
import type { OpResult } from "./op-types.js"

export async function updateUserStatus(
  id: string,
  userStatus: string | undefined,
): Promise<OpResult> {
  const db = getDb()
  try {
    await db.totodo.update(id, {
      userStatus: userStatus ?? undefined,
      updatedAt: getNow(),
    })
    return ok()
  } catch (e) {
    return fail(
      `updateUserStatus failed: ${e instanceof Error ? e.message : String(e)}`,
    )
  }
}

export async function bulkUpdateUserStatus(
  ids: string[],
  userStatus: string | undefined,
): Promise<OpResult> {
  const db = getDb()
  try {
    const timestamp = getNow()
    await db.transaction("rw", db.totodo, async () => {
      for (const id of ids) {
        await db.totodo.update(id, {
          userStatus: userStatus ?? undefined,
          updatedAt: timestamp,
        })
      }
    })
    return ok()
  } catch (e) {
    return fail(
      `bulkUpdateUserStatus failed: ${e instanceof Error ? e.message : String(e)}`,
    )
  }
}
